module.exports = __webpack_public_path__ + "static/img/gif-1.3038021.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/gif-1.gif
// module id = Hy3A
// module chunks = 1